export const CRITERIABASICHEIGHT = 69 // 高级查询-基本高度
export const CRITERIFORMCOLUM = 6 // 高级查询-表单-6列
